import React, { useState } from "react";
import { usePartnerMissionStore } from "../../../../stores/Cac/Partner/partnerMission";
import {
  showToastError,
  showToastSuccess,
} from "../../../../services/Toasts/toasts";
import {
  archiveMission,
  handleExportCSV,
} from "../../../../services/Api/customerService";
import { useParams } from "react-router-dom";

const PartnerModalArchiveMission = () => {
  const { idCustomer } = useParams();
  // Store
  const { missionId, setChoiceModal } = usePartnerMissionStore();
  const [value, setValue] = useState<string>("");

  // Function for verify value for archive mission and download csv
  const verifyValue = (value: string) => {
    if (value === "archiver") {
      archiveMission(
          Number(idCustomer),
          Number(missionId)
        )
        .then((response) => {
          showToastSuccess("L'archivage a bien été effectué !");
          setValue("");
          setChoiceModal("");
          handleExportCSV(Number(idCustomer), Number(missionId));
        }).catch((error) => {
          showToastError(
            "L'archivage a échoué car il reste une ou plusieurs requête(s) non acceptée(s)!"
          );
        });
    }
  };

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (e.key === "Enter") {
      verifyValue(value);
    }
  };
  
  return (
    <>
      <div className="fixed inset-0 z-50 flex items-center justify-center overflow-y-auto p-3 outline-hidden focus:outline-hidden sm:p-6">
        <div className="relative mx-auto w-full max-w-lg">
          {/* Content */}
          <div className="relative flex w-full flex-col rounded-2xl border-0 bg-white shadow-2xl outline-hidden focus:outline-hidden">
            {/* Header */}
            <div className="w-full rounded-t-xl bg-white p-4">
              <h4 className="flex items-center gap-2 text-lg font-semibold text-gray-700 sm:text-xl">
                <svg className="w-5 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.375 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h13.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                </svg>
                Archivage de mission
              </h4>
            </div>
            {/* Body */}
            <div className="w-full flex flex-col items-center justify-center text-grey-trio">
              <div className="mb-6 flex w-full flex-col items-center justify-center px-5">
                <div className="w-16 h-16 bg-blue-100 rounded-full flex items-center justify-center mb-4">
                  <svg className="w-8 h-8 text-blue-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.375 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h13.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                  </svg>
                </div>
                <h3 className="text-lg font-semibold text-gray-700 mb-2 text-center">
                  Confirmation d'archivage
                </h3>
                <p className="text-md text-gray-600 text-center mb-4">
                  Pour archiver cette mission, veuillez confirmer en écrivant le mot "archiver" dans le champ ci-dessous.
                </p>
                <div className="w-full max-w-xs">
                  <input
                    type="text"
                    className="w-full h-10 px-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent shadow-sm"
                    placeholder="Tapez 'archiver'"
                    onKeyDown={handleKeyDown}
                    onChange={(e) => {
                     const value = e.target.value;
                     setValue(value);
                    }}
                    value={value}
                  />
                </div>
                <p className="text-sm text-gray-500 text-center mt-3 italic">
                  Cette action archivera définitivement la mission.
                </p>
              </div>
            </div>

            {/* Footer */}
            <div className="flex items-center justify-end gap-3 rounded-b-2xl bg-white p-3">
              <button
                className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-gray-100 px-4 py-2 text-sm font-semibold text-gray-500 transition-all duration-200 hover:bg-gray-200 sm:flex-none"
                type="button"
                onClick={() => setChoiceModal("")}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                </svg>
                Annuler
              </button>
              <button
                className="flex min-h-11 flex-1 cursor-pointer items-center justify-center gap-2 rounded-xl bg-blue-600 px-4 py-2 text-sm font-semibold text-white shadow-lg transition-all duration-200 hover:bg-blue-700 hover:shadow-xl sm:flex-none sm:hover:scale-105"
                type="button"
                onClick={() => {
                  if (value.toLowerCase() === "archiver") {
                    verifyValue(value);
                  }
                }}
              >
                <svg className="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20.25 7.5l-.625 10.632a2.25 2.25 0 01-2.247 2.118H6.622a2.25 2.25 0 01-2.247-2.118L3.375 7.5m8.25 3v6.75m0 0l-3-3m3 3l3-3M3.375 7.5h13.5c.621 0 1.125-.504 1.125-1.125v-1.5c0-.621-.504-1.125-1.125-1.125H3.375c-.621 0-1.125.504-1.125 1.125v1.5c0 .621.504 1.125 1.125 1.125z" />
                </svg>
                Archiver
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
    </>
  );
};

export default PartnerModalArchiveMission;
